import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { listClientsheetsApiV1ClientsheetGet } from "@/client";
import { columns } from "@/components/ClientsheetTable/columns";
import { DataTable } from "@/components/ClientsheetTable/data-table";
import { LoadingComponent } from "@/components/LoadingComponent";
import { checkPermission } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/clientsheets/archive")({
  component: ClientsheetsArchivePage,
  beforeLoad: () => {
    checkPermission("clientsheet:read");
  },
});

function ClientsheetsArchivePage() {
  const { data: clientsheets, isLoading } = useQuery({
    queryKey: ["clientsheets"],
    queryFn: async () => {
      const response = await listClientsheetsApiV1ClientsheetGet();
      return response.data;
    },
  });

  if (isLoading || !clientsheets) {
    return <LoadingComponent />;
  }

  return <DataTable data={clientsheets} columns={columns} />;
}
